/* eslint-disable max-len */

import Vue from 'vue';
import moment from 'moment';

export const powerScalesState = {
  averagePowerScales: {},
};

const zones = [
  { zone: 1, low: 0.65, high: 0.8 },
  { zone: 2, low: 0.8, high: 0.9 },
  { zone: 3, low: 0.9, high: 1.0 },
  { zone: 4, low: 1.0, high: 1.15 },
  { zone: 5, low: 1.15, high: 1000 },
];

const defaultVelocity = {
  0: 2.68, 1: 2.68, 2: 2.68, 3: 2.68, 4: 2.68, 5: 2.68,
};

const defaultPace = {
  0: [10, 10], 1: [10, 10], 2: [10, 10], 3: [10, 10], 4: [10, 10], 5: [10, 10],
};

const defaultPower = {
  0: 300, 1: 300, 2: 300, 3: 300, 4: 300, 5: 300,
};

export const powerScalesGetters = {
  velocity: state => zone => ((state.averagePowerScales[state.activeCalendar] || {}).velocity || defaultVelocity)[zone.toString()],
  pace: state => zone => (state.averagePowerScales[state.activeCalendar].pace || defaultPace)[zone.toString()],
  averagePower: state => zone => (state.averagePowerScales[state.activeCalendar].power || defaultPower)[zone.toString()],
  powerZoneRanges: (state, getters) => day => zones.reduce((a, z) => ({
    ...a,
    [z.zone]: [z.low * getters.day(day).criticalPower, z.high * getters.day(day).criticalPower],
  }), {}),
  hasPowerScaleData: state => state.averagePowerScales[state.activeCalendar] && state.averagePowerScales[state.activeCalendar].power !== undefined,
};

export const powerScalesMutations = {
  loadAveragePowerScales(state, { memberId, data }) {
    Vue.set(state.averagePowerScales, memberId, data);
  },
};

export const powerScalesActions = {
  async loadAveragePowerScales(context, memberId) {
    const result = await this.$container.dao.getAveragePowerScales(
      memberId,
      context.getters.criticalPowerNow || 0,
    );
    context.commit('loadAveragePowerScales', {
      memberId,
      data: result.data,
    });
  },
};
